import { Box, Button, } from '@mui/material'
import React, { useState } from 'react'

function ProductsLink() {
    const [pages, setPages] = useState(["New Products", "On Sell",])
    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', my: 2 }}>
            <Box sx={{ width: '50%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                {pages.map((page) => (
                    <Button key={page}
                        sx={{
                            my: 2, mx: 1, color: 'black', border: 'none', position: 'relative', textTransform: 'capitalize',
                            transition: 'color 0.3s ease, transform 0.3s ease',
                            '&:hover': {
                                color: '#f5b600', // Hover color
                                transform: 'translateX(5px)', // Slight move to the right
                            },
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                width: '100%',
                                height: '2px',
                                backgroundColor: '#f5b600',
                                left: 0,
                                bottom: 0,
                                transform: 'scaleX(0)',
                                transformOrigin: 'left',
                                transition: 'transform 0.3s ease',
                            },
                            '&:hover::after': {
                                transform: 'scaleX(1)', // Line grows from left to right
                            },
                        }}
                    >
                        {page}
                    </Button>
                ))}
            </Box>
        </Box>
    )
}

export default ProductsLink